import { BrandliveEvent } from '../../../types/working-model';
import { Session } from '../../../types/working-model';
import SessionItem from './session-item';

interface Props {
	sessionList: Session[];
	selectedEvent: BrandliveEvent;
}

export default function SessionList(props: Props): JSX.Element {
	const { sessionList, selectedEvent } = props;

	return (
		<div className="session-list">
			{sessionList.map((session: Session) => {
				return (
					<SessionItem
						key={session.uuid}
						session={session}
						selectedEvent={selectedEvent}
					/>
				);
			})}
		</div>
	);
}